<template>
  <div>
    <el-row :gutter="10">
      <el-col :md="8">
        <el-card>
          <zee-payments-searchbar :existing-search-query="searchQuery"></zee-payments-searchbar>
        </el-card>
      </el-col>
      <el-col :md="7">
        <el-card>
          <zee-payments-list-filter :selected-filters="filterSelected"></zee-payments-list-filter>
        </el-card>
      </el-col>
      <el-col :md="9">
        <el-card>
          <zee-payments-by-due-date></zee-payments-by-due-date>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <zee-payments-list></zee-payments-list>
    </el-row>
  </div>
</template>
<script>
import * as types from '@/store/mutation-types';
import { mapGetters } from 'vuex';
import zeePaymentsListFilter from './partials/PaymentsListFilter.vue';
import zeePaymentsListActions from './partials/PaymentsListActions.vue';
import zeePaymentsList from './partials/PaymentsList.vue';
import zeePaymentsSearchbar from './partials/PaymentsSearchbar.vue';
import zeePaymentsByDueDate from './partials/PaymentsByDueDate.vue';

export default {
  components: {
    zeePaymentsListFilter,
    zeePaymentsListActions,
    zeePaymentsList,
    zeePaymentsSearchbar,
    zeePaymentsByDueDate,
  },
  data() {
    return {
      dueSoonQuery: '',
      searchQuery: '',
      filterSelected: [],
    };
  },
  computed: {
    ...mapGetters({
      getPaymentSearchQueryString: 'getPaymentSearchQueryString',
      getSearchPaymentQuery: 'getSearchPaymentQuery',
      getsearchPaymentFilterSelected: 'getsearchPaymentFilterSelected',
      isPaymentsFirstLoad: 'isPaymentsFirstLoad',
    }),
  },
  beforeMount() {
    document.querySelector('body').className = 'is-payments';
  },
  created() {
    // set initial search query
    const searchQueryPayments = this.getSearchPaymentQuery.replace('q=', '');
    this.searchQuery = searchQueryPayments;
    // set initial filter query
    const filterSelectedPayments = this.getsearchPaymentFilterSelected;
    this.filterSelected = filterSelectedPayments;

    if (this.isPaymentsFirstLoad) {
      this.$store.dispatch('getSearchedPaymentTransactionsData');
      this.$store.commit(types.SET_IS_PAYMENTS_FIRST_LOAD, false);
    }
  },
};
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-notification .el-icon-warning {
  color: #e74c3c;
}
</style>




// WEBPACK FOOTER //
// src/components/payments/Payments.vue